import { andWhatNext } from '../../../helpers'
import Fragment from '../../../components/Fragment'
import useStyles from './styles'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'

const SectionPetition = ({ fragments, width, postcode }) => {
  const desktop = isWidthUp('md', width)
  const classes = useStyles({ width, desktop })

  const chunks = (chunk) => {
    switch (chunk) {
      case 'action':
        return (
          <Grid item className={classes.action}>
            <Typography
              variant="body1"
              style={{ color: 'white', width: '100%' }}
              align={'center'}
            >
              <Fragment title={'action_petition_cta_text'} fragments={fragments} />
            </Typography>

            <Button
              color="primary"
              variant="contained"
              size="large"
              onClick={() =>
                (window.location.href = andWhatNext('results', {
                  postcode,
                  actionType: 'petition',
                }))
              }
              className={classes.actionButton}
              fullWidth
            >
              <Fragment title={'action_petition_cta_button'} fragments={fragments} />
            </Button>
          </Grid>
        )
    }
  }

  return desktop ? (
    <Grid container direction="row" className={classes.container} justify="center">
      <Grid item md={5} lg={4}>
        {chunks('action')}
      </Grid>
    </Grid>
  ) : (
    <Grid container direction="column" className={classes.container} spacing={2}>
      {chunks('action')}
    </Grid>
  )
}

export default withWidth()(SectionPetition)
